<template>
    <div></div>
</template>

<script>
export default {
    components: {},
    mounted() {
        const selectedMileage = localStorage.getItem('selectedProduct')
        const selectedProduct = localStorage.getItem('selectedMileage')
        const selectedDuration = localStorage.getItem('selectedDuration')
        const selectedTier = localStorage.getItem('selectedTier')

        if (this.$root.user.state.loggedIn) {
            if (selectedMileage && selectedProduct && selectedDuration) {
                this.$axios.post('api/v1/checkout/init_checkout', {
                vehicle_uuid: selectedMileage,
                mileage: selectedProduct,
                duration: selectedDuration,
                tier_uuid: selectedTier
             }).then(response => {
                if (response.data) {
                    this.$goTo('checkout', { identifier: response.data.data.identifier })
                } else {
                    this.$goTo('catalog')
                }
            }).catch(error => {
                this.$goTo('catalog')
                });
            } else {
                this.$goTo('catalog')
            }
        } else {
            let isInCheckout = 'false'
            if (selectedProduct && selectedMileage && selectedDuration) {
                isInCheckout = 'true'
            }

            this.$goTo('login', null, { isInCheckout: isInCheckout })
        }
    }
}
</script>
